import { render, staticRenderFns } from "./DataSurvey.vue?vue&type=template&id=2b677cca&scoped=true&"
import script from "./DataSurvey.vue?vue&type=script&lang=js&"
export * from "./DataSurvey.vue?vue&type=script&lang=js&"
import style0 from "./DataSurvey.vue?vue&type=style&index=0&id=2b677cca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b677cca",
  null
  
)

export default component.exports